import React from "react";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
import HeaderOne from "../../components/layout/HeaderOne";
import HeaderHome from "../../components/layout/HeaderHome";
import Breadcrumb from "../../components/Breadcrumb";
import BreadcrumbImage from "../../components/BreadcrumbImage";
import WhyBecomeSeller from "../../components/WhyBecomeSeller";
import CounterSection from "../../components/CounterSection";
import StepsSection from "../../components/StepsSection";
import TestimonialOne from "../../components/TestimonialOne";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";
import Package from "../../components/becomeaseller/packagesList"; 
import ReviewTop from "../../components/becomeaseller/SellerReviewTop"; 
import ReviewBottom from "../../components/becomeaseller/SellerReviewBottom"; 
import FAQ from "../../components/becomeaseller/FAQ"; 


const BecomeSellerPage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color='#990A02' />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      {/* <HeaderOne /> */}
      <HeaderHome />

      {/* Breadcrumb */}
      <Breadcrumb title={"Become Seller"} />

      {/* BreadcrumbImage */}
      <BreadcrumbImage />

      {/* WhyBecomeSeller */}
      <WhyBecomeSeller />

      {/* CounterSection */}
      <CounterSection />

      {/* StepsSection */}
      <StepsSection />

      <Package />

      <ReviewTop />

      <ReviewBottom />

      <FAQ />

      {/* TestimonialOne */}
      {/* <section className='pb-120'>
        <TestimonialOne />
      </section> */}

      {/* ShippingOne */}
      {/* <ShippingOne /> */}

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default BecomeSellerPage;
